/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Foreignlanguages1Inputs */

const en__field_foreignlanguages1 = /** @type {(inputs: _Field_Foreignlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foreign Languages`)
};

const de__field_foreignlanguages1 = /** @type {(inputs: _Field_Foreignlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fremdsprachen`)
};

/**
* | output |
* | --- |
* | "Foreign Languages" |
*
* @param {_Field_Foreignlanguages1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_foreignlanguages1 = /** @type {((inputs?: _Field_Foreignlanguages1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Foreignlanguages1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_foreignlanguages1(inputs)
	return de__field_foreignlanguages1(inputs)
});
export { _field_foreignlanguages1 as "_field_foreignLanguages" }